import { is } from 'bpmn-js/lib/util/ModelUtil';
import { isExpanded } from 'bpmn-js/lib/util/DiUtil';

/**
 * Adds a dedicated "Collapse" / "Expand" button to the context pad of
 * sub-process shapes.  This makes the toggle more discoverable than the
 * built-in wrench (replace) menu entry.
 */
export default function CollapseToggleContextPadProvider(contextPad, modeling, translate) {
  contextPad.registerProvider(900, this);

  this._modeling = modeling;
  this._translate = translate;
}

CollapseToggleContextPadProvider.$inject = ['contextPad', 'modeling', 'translate'];

CollapseToggleContextPadProvider.prototype.getContextPadEntries = function (element) {
  const modeling = this._modeling;
  const translate = this._translate;

  if (!is(element, 'bpmn:SubProcess')) return {};

  const expanded = isExpanded(element);

  if (expanded) {
    return {
      'toggle-collapse-subprocess': {
        group: 'edit',
        className: 'bpmn-icon-subprocess-collapsed',
        title: translate('Zuklappen'),
        action: {
          click: (_event, el) => {
            modeling.toggleCollapse(el || element);
          }
        }
      }
    };
  }

  // Collapsed sub-process — offer expand
  return {
    'toggle-expand-subprocess': {
      group: 'edit',
      className: 'bpmn-icon-subprocess-expanded',
      title: translate('Aufklappen'),
      action: {
        click: (_event, el) => {
          modeling.toggleCollapse(el || element);
        }
      }
    }
  };
};
